import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'
import { MAX_SECONDS_PER_MOTE, MILLISECONDS_PER_CHUNK } from '@mote/helpers'

export interface MoteConfigValue {
  maxSeconds: number
  millisecondsPerChunk: number
}

const defaultValue = {
  maxSeconds: MAX_SECONDS_PER_MOTE,
  millisecondsPerChunk: MILLISECONDS_PER_CHUNK
}
export const MoteConfigContext = createContext<MoteConfigValue>(defaultValue)

interface ReactionsContextProviderProps extends PropsWithChildren {}

export function MoteConfigContextProvider(
  props: ReactionsContextProviderProps
): JSX.Element {
  return (
    <MoteConfigContext.Provider value={defaultValue}>
      {props.children}
    </MoteConfigContext.Provider>
  )
}

export function useMoteConfigContext() {
  const value = useContext(MoteConfigContext)
  return value
}
